<!-- Modal.vue -->
<template>
  <div v-show="show" class="modal">
    <div class="modal-content">
      <span class="modal-close" @click="close">&times;</span>
      <!-- Modal content slot -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
